import React from 'react';
import style from './style.module.scss';
const GalleryLayout = ({ children }) => {
  return <div className={style.galleryContainer}>{children}</div>;
};

export default GalleryLayout;
